export default __webpack_public_path__ + "static/media/pick.b6d5a48f.svg";